import { render, staticRenderFns } from "./gouMai.vue?vue&type=template&id=965a6de8&scoped=true&"
import script from "./gouMai.vue?vue&type=script&lang=js&"
export * from "./gouMai.vue?vue&type=script&lang=js&"
import style0 from "./gouMai.vue?vue&type=style&index=0&id=965a6de8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "965a6de8",
  null
  
)

export default component.exports